module.exports = __webpack_public_path__ + "img/zaoj.d4e5bef6.png";